<div class="filter-select-container">
  <mat-icon
    aria-hidden="false"
    class="rds-c-selection-info-icon"
    [mtnaPopover]="config"
    [mtnaClosePopoverAriaLabel]="_TEXT_filter | rdsPopoverAriaLabel: false"
    [mtnaOpenPopoverAriaLabel]="_TEXT_filter | rdsPopoverAriaLabel: true"
    >info</mat-icon
  >
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{ _TEXT_filter }}</mat-label>
    <mat-select
      [compareWith]="_compareVariable"
      [disabled]="disabled"
      i18n-placeholder
      placeholder="Choose a filter..."
      [value]="filters?.length || 0 | rdsGetFilterValue: filters || []:multiVariableSelect"
      (openedChange)="handleOpenedChange($event)"
      (selectionChange)="handleSelectChange($event)"
      [multiple]="multiVariableSelect"
      panelClass="rds-c-dimension-virtual-scroll-panel"
    >
      <mat-select-trigger>
        <span *ngIf="filters | rdsFirstItem as filter">
          {{ filter?.variable | rdsVariableDisplay }}
        </span>
        <span *ngIf="(filters?.length || 0) > 1" class="hidden-selections-text" [ngPlural]="filters!.length">
          (+{{ filters!.length - 1 + ' ' }}
          <ng-template ngPluralCase="=2" i18n>other</ng-template>
          <ng-template ngPluralCase="other" i18n>others</ng-template>)
        </span>
      </mat-select-trigger>
      <mtna-select-search [noResultsFound]="_noSearchResults" (search)="filterVariables($event)"></mtna-select-search>
      <cdk-virtual-scroll-viewport [class.no-results]="_noSearchResults" itemSize="48" [maxBufferPx]="48 * 12" [minBufferPx]="48 * 7">
        <mat-option *ngIf="filters?.length" i18n>None</mat-option>
        <mat-option *cdkVirtualFor="let variable of _varFilteredSummaries$ | async; trackBy: _trackByVariable" [value]="variable">
          <span
            ><strong>{{ variable.id }}</strong></span
          >
          <span *ngIf="variable.label"> - {{ variable.label }}</span>
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </mat-select>
    <mat-icon matSuffix>filter_list</mat-icon>

    <ng-container *ngFor="let filter of filters">
      <button
        class="rds-c-variable-button mat-caption"
        [matTooltip]="_modifyFilterForPlaceholder + (filter.variable | rdsVariableDisplay)"
        matTooltipPosition="after"
        type="button"
        (click)="$event.stopPropagation(); openFilterDialog(filter.variable.uri)"
      >
        {{ filter.variable | rdsVariableDisplay }}
        <ng-container *ngIf="filter | coerceFilterByCodes as codeFilter">
          <ng-container *ngIf="codeFilter.excludeCodes" i18n>(excluded)</ng-container>
        </ng-container>
      </button>
      <rds-c-chips
        *ngIf="filter | rdsFilterSummaryChips as summary"
        [ariaLabel]="filter.variable | rdsVariableDisplay"
        [chips]="summary.chips"
        [selectable]="false"
        [removable]="true"
        [vertical]="true"
        (removed)="removeFilter(filter, summary.filterType, $event)"
        (selected)="openFilterDialog(filter.variable.uri)"
      ></rds-c-chips>
    </ng-container>
  </mat-form-field>
</div>
